export default {
  key: {
    '0': 'jan',
    '1': 'feb',
    '2': 'mar',
    '3': 'apr',
    '4': 'may',
    '5': 'jun',
    '6': 'jul',
    '7': 'aug',
    '8': 'sep',
    '9': 'oct',
    '10': 'nov',
    '11': 'dec',
  },
  long: {
    jan: "Januari",
    feb: "Februari",
    mar: "Maart",
    apr: 'April',
    may: 'Mei',
    jun: 'Juni',
    jul: 'Juli',
    aug: 'Augustus',
    sep: 'September',
    oct: 'Oktober',
    nov: 'November',
    dec: 'December',
  },
  short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mrt",
    apr: 'Apr',
    may: 'Mei',
    jun: 'Juni',
    jul: 'Juli',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Okt',
    nov: 'Nov',
    dec: 'Dec',
  }
}
